
function EsgCard({ title, subtitle, description, cta, Icon, className, minHeight, audience, ctaLink }) {
    return (
        <div className={`${className || ""} h-full flex flex-col`}>
            <div className={`flex flex-col justify-start p-6 bg-white border border-[#C6C6C6] rounded-[12px] h-full flex-grow`} style={{ minHeight: minHeight === '100%' ? '100%' : (minHeight || 'auto') }}>
                <div className="flex items-start gap-4">
                    <div className="flex items-center justify-center flex-shrink-0 p-4 text-white bg-orange-500 rounded-[8px] rounded-tr-[40px]">
                        <img src={Icon} alt="esg-advisory" className="w-8 h-8 object-contain" />
                    </div>
                </div>
                <div className="flex-grow flex flex-col">
                    {title && <h3 className="my-2 text-lg font-semibold leading-tight text-gray-900">
                        {title}
                    </h3>}
                    {subtitle && <h4 className="mb-2 text-base font-semibold leading-tight text-gray-700">
                        {subtitle}
                    </h4>}
                    <p className="text-base leading-relaxed text-[#838383] flex-grow text-justify">
                        {description}
                    </p>
                    {cta && <button onClick={() => window.location.href = ctaLink} className="mt-3 text-sm font-semibold text-[#1C486B] transition-colors text-start self-start">
                        {cta}
                    </button>}
                    {audience && audience.length > 0 &&
                        <div className="flex flex-wrap justify-start gap-2 mt-3 text-[500]">
                            <p className="text-base leading-relaxed text-[#838383]">Audience:</p>
                            {audience.map((item, index) => {
                                return (
                                    <p key={index} className="text-base leading-relaxed text-white bg-[#EB7E0E] py-[3px] px-2 rounded-2xl">{item}</p>
                                )
                            })}
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}



export default EsgCard;

